import React from 'react'

function Ratings() {
    return (
        <div>
            <h1>Layout add will soon</h1>
        </div>
    )
}

export default Ratings
